import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db86b1b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timelapse_wrapper" }

import Live from './components/Live'
import Archive from './components/Archive'
import { CameraDetail } from '@/@types/typescript-axios'


type displaySizeType = {
  width: number
  height: number
}

type PropsType = {
  cameraDetail: CameraDetail
  useLive: boolean
  displaySize: displaySizeType
}


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  props: {
    cameraDetail: null,
    useLive: { type: Boolean },
    displaySize: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.useLive)
      ? (_openBlock(), _createBlock(_unref(Live), {
          key: 0,
          "camera-detail": __props.cameraDetail,
          "display-size": __props.displaySize
        }, null, 8, ["camera-detail", "display-size"]))
      : (_openBlock(), _createBlock(_unref(Archive), { key: 1 }))
  ]))
}
}

})